






import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class SubTaskList extends Vue {}
